import React from 'react';
import {Link} from "react-router-dom";

const CovidPage = () => (
    <div className='content'>
        <h1>Covid 19 Updates</h1>
        <h3>Phase 2 operation info:</h3>
        <p>
            Little Nest is currently open during Phase 2 of the Washington State reopen plan.  We are
            operating very small classes (max 8 kids) using the "pods" model.
        </p>
        <p>
            example:
        </p>
        <ul>
            <li>pod A meets Tuesday and Wednesday</li>
            <li>pod B meets Thursday and Friday</li>
        </ul>
        <p>
            Once the State moves into one of the next stages of reopening, we will be offering more
            days and our capacity will increase.
        </p>
        <Link to='/enrollment'>
            <p>
                Little Nest is full for Phase 2 enrollment.
            </p>
        </Link>
    </div>
);

export default CovidPage;



// WEBPACK FOOTER //
// ./src/components/CovidPage.js